angular.module('tf.directives')


    .constant('PasswordStrengthDetails', {
        0: {text : "Worst", color : "black"},
        1: {text : "Bad" , color : "red"},
        2: {text : "Weak" , color : "yellow"},
        3: {text : "Good" , color : "orange"},
        4: {text : "Strong" , color : "green"}
    })

    .directive('passwordStrength', ['PasswordStrengthDetails', function (PasswordStrengthDetails) {
            return{

                restrict:'E',
                replace:true,
                scope:{
                    password : '=',
                },
                template:'<div>' +
                            '<span class="password-strength-text"></span>' +
                            '<meter max="4" class="password-strength-meter"></meter>' +
                         '</div>',
                link: function(scope,element,attr){

                    var meterEl = element.find('.password-strength-meter');
                    var textEl = element.find('.password-strength-text');

                    function strength(){
                        if(scope.password){
                            var strength = zxcvbn(scope.password);
                            meterEl.show();
                            meterEl[0].value = strength.score;
                            textEl[0].innerText = PasswordStrengthDetails[strength.score].text;
                        } else {
                            meterEl.hide();
                            meterEl[0].value = 0;
                            textEl[0].innerText = '';
                        }
                    }

                    scope.$watch('password', strength);

                }
            };
        }])

    .directive('passwordStrength', ['PasswordStrengthDetails', function (PasswordStrengthDetails) {
        return{

            restrict:'A',
            require: 'ngModel',
            scope:{
                ngModel: '=',
            },
            link: function(scope,element,attr){

                var wrapper = document.createElement('div');
                wrapper.setAttribute('class', 'password-strength-wrapper');
                element.wrapAll(wrapper);

                var passwordStringIndicator = document.createElement('span');
                passwordStringIndicator.setAttribute('class','password-strength-indicator');
                element.after(passwordStringIndicator);

                function strength(){
                    if(scope.ngModel){
                        var strength = zxcvbn(scope.ngModel);
                        var details = PasswordStrengthDetails[strength.score];
                        element.css('border-color', details.color);
                        passwordStringIndicator.innerText = details.text;

                    } else {
                        element.css('border-color', '');
                        passwordStringIndicator.innerText = '';
                    }
                }

                scope.$watch('ngModel', strength);

            }
        };
    }])

;


